import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets//icon//screenshot.png'


const _withScopeId = n => (_pushScopeId("data-v-f4aa2d4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-time" }
const _hoisted_2 = { class: "img" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "evaluate"
}
const _hoisted_5 = {
  key: 1,
  class: "evaluate"
}
const _hoisted_6 = { class: "img" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "evaluate"
}
const _hoisted_10 = {
  key: 1,
  class: "evaluate"
}
const _hoisted_11 = {
  key: 0,
  class: "loding"
}
const _hoisted_12 = {
  key: 1,
  class: "d-btn"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kong" }, null, -1))
const _hoisted_14 = {
  key: 2,
  class: "d-foot"
}
const _hoisted_15 = {
  key: 3,
  class: "d-foot"
}

import NavBar from "../../components/navBar/index.vue";
import Loading from "@/components/loading/index.vue";
import { Image, Button, showConfirmDialog, Divider, showFailToast } from "vant";
import { Ref, ref, reactive, nextTick } from "vue";
import html2canvas from "html2canvas";
import axios from "axios";
import API from "@/api/index";
import MarkdownIt from "markdown-it";
type Evaluate = "like" | "badreview" | false | true;
interface MsgList {
  img: string;
  time: string;
  cnt: string;
  user: boolean; //判断是否是使用者还是AI的回答
  evaluate: Evaluate; //判断该条评论是否展示评价按钮或者其评价状态
  gather: boolean; //判断该条评论是否展示数据采集单
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const markdown = new MarkdownIt();

let histroyList = reactive<Array<Array<MsgList>>>([]);
let msgList = reactive<Array<MsgList>>([
  {
    img: "../../assets/icon/PropertyAI.png",
    time: "2023/6/14 15:55:50",
    cnt: "您好，很高兴为您服务。我是创噬纪AI客服，我的名字叫纪噬本（ChatPhage）。我可以解答一些关于噬菌体技术、应用和业务相关的问题。若您有这方面的问题或需求，可以随时跟我聊天。",
    user: false,
    evaluate: false,
    gather: false,
  },
]);

/** 消息发送 */
let msg: Ref<string> = ref("");
let historyArr: Array<[string, string]> = [];
const sending = ref(false);
const sendMsg = () => {
  sending.value = true;
  msgList.push({
    img: "",
    time: "2023/6/14 15:55:50",
    cnt: msg.value,
    user: true,
    evaluate: false,
    gather: false,
  });
  autoScroll();

  //api
  const data = {
    prompt: msg.value,
    history: historyArr,
  };
  API.chatphage(data)
    .then((res: any) => {
      historyArr = res.data.history;
      msgList.push({
        img: "",
        time: res.data.time,
        cnt: res.data.response,
        user: false,
        evaluate: false,
        gather: false,
      });
      const l = msgList.length - 1;
      for (let i = l; i > 0; i--) {
        if (msgList[i]?.evaluate === true) {
          msgList[i].evaluate = false;
          break;
        }
      }
      autoScroll();
      sending.value = false;
    })
    .catch(() => {
      showFailToast("连接失败，请重新尝试");
      sending.value = false;
    });
  msg.value = "";
};

/**评价处理 */
const evaluate: Ref<Evaluate> = ref(false);
const changeEvaluate = (e: Evaluate) => {
  const l = msgList.length - 1;
  for (let i = l; i > 0; i--) {
    if (msgList[i].evaluate) {
      msgList[i].evaluate = e;
      break;
    }
  }
  const data = {
    value: e,
  };
  //api
  axios.post("/api/postEvaluate", data).then((response) => {
    msgList.push(response.data);
    evaluate.value = e;
  });
};

/** 结束咨询 */
const noService = () => {
  //api
  const data = {
    value: "不需要",
  };
  axios.post("/api/postAnswer", data).then((response) => {
    msgList.push(response.data);
    histroyList.push(msgList);
    msgList = reactive([]);
    evaluate.value = false;
    console.log(histroyList, "历史");
    console.log(msgList, "当前");
  });
};

/** 发起新咨询 */
const newService = () => {
  msgList.push({
    img: "",
    time: "2023/6/14 15:55:50",
    cnt: "您好，很高兴为您服务。我是创噬纪AI客服，我的名字叫纪噬本（ChatPhage）。我可以解答一些关于噬菌体技术、应用和业务相关的问题。若您有这方面的问题或需求，可以随时跟我聊天。",
    user: false,
    evaluate: false,
    gather: false,
  });
  console.log(msgList);
};

/** 保存截图 */
const saveMsg = () => {
  showConfirmDialog({
    message: "保存最近对话为图片",
    confirmButtonText: "保存",
  })
    .then(() => {
      clickGeneratePicture("id123");
    })
    .catch(() => {
      // on cancel
    });
};

const imageWrapper = ref(null) as any;
// 截图
const clickGeneratePicture = (id: any) => {
  html2canvas(imageWrapper.value, {
    logging: false,
    allowTaint: true,
    scale: window.devicePixelRatio,
    // width: shareContent.clientWidth, //dom 原始宽度
    // height: shareContent.clientHeight,
    scrollY: 0,
    scrollX: 0,
    useCORS: true,
    backgroundColor: "#ffffff",
  }).then((canvas) => {
    console.log(canvas);
    let imgUrl = canvas.toDataURL("image/jpg");
    var tempLink = document.createElement("a"); // 创建一个a标签
    tempLink.style.display = "none";
    tempLink.href = imgUrl;
    tempLink.setAttribute("download", id); // 给a标签添加下载属性
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    document.body.appendChild(tempLink); // 将a标签添加到body当中
    tempLink.click(); // 启动下载
    document.body.removeChild(tempLink); // 下载完毕删除a标签
    window.URL.revokeObjectURL(imgUrl);
  });
};

/** 自动定位到底部  */
const scrollContainer = ref(null) as any;
const autoScroll = () => {
  nextTick(() => {
    scrollContainer.value.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "end",
    });
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavBar, {
      title: "纪噬本ChatPhage",
      iconLeft: "cross"
    }),
    _createElementVNode("div", {
      class: "home",
      ref_key: "scrollContainer",
      ref: scrollContainer
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(histroyList), (itemc, indexc) => {
        return (_openBlock(), _createElementBlock("div", { key: indexc }, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemc, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(item.time), 1),
                _createElementVNode("div", {
                  class: "block",
                  style: _normalizeStyle(item.user ? 'flex-direction: row-reverse' : '')
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Image), {
                      round: "",
                      width: "32px",
                      height: "32px",
                      src: require('../../assets/icon/PropertyAI.png')
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", {
                    class: "arrow",
                    style: _normalizeStyle(
                item.user
                  ? 'border-left: 12px solid #fff;margin-right: 8px;'
                  : 'border-right: 12px solid #fff;;margin-left: 8px;'
              )
                  }, null, 4),
                  _createElementVNode("div", {
                    class: "info",
                    style: _normalizeStyle(item.user ? 'text-align: right' : '')
                  }, [
                    _createElementVNode("div", {
                      class: "cnt",
                      innerHTML: _unref(markdown).render(item.cnt)
                    }, null, 8, _hoisted_3),
                    (item.evaluate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_unref(Button), {
                            disabled: "",
                            icon: 
                    item.evaluate === 'like'
                      ? require('../../assets/icon/zan-full.png')
                      : require('../../assets/icon/zan.png')
                  ,
                            plain: "",
                            color: item.evaluate === 'like' ? '#1989FA' : '#969799',
                            class: "van-btn",
                            size: "small",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeEvaluate('like')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("满意")
                            ]),
                            _: 2
                          }, 1032, ["icon", "color"]),
                          _createVNode(_unref(Button), {
                            disabled: "",
                            icon: 
                    item.evaluate === 'badreview'
                      ? require('../../assets/icon/bumanyi-full.png')
                      : require('../../assets/icon/bumanyi.png')
                  ,
                            plain: "",
                            color: item.evaluate === 'badreview' ? '#1989FA' : '#969799',
                            class: "van-btn",
                            size: "small",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeEvaluate('badreview')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("不满意")
                            ]),
                            _: 2
                          }, 1032, ["icon", "color"]),
                          _createVNode(_unref(Button), {
                            disabled: "",
                            icon: require('../../assets/icon/sync.png'),
                            plain: "",
                            color: "#969799",
                            class: "van-btn",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("重回答")
                            ]),
                            _: 1
                          }, 8, ["icon"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.gather)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_unref(Button), {
                            disabled: "",
                            icon: require('../../assets/icon/collection.png'),
                            plain: "",
                            color: "#1989FA",
                            class: "van-btn",
                            size: "small",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/collectionFrom')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("受试者信息采集单")
                            ]),
                            _: 1
                          }, 8, ["icon"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 4)
                ], 4)
              ]))
            }), 128))
          ]),
          _createVNode(_unref(Divider), null, {
            default: _withCtx(() => [
              _createTextVNode("对话已结束")
            ]),
            _: 1
          })
        ]))
      }), 128)),
      _createElementVNode("div", {
        ref_key: "imageWrapper",
        ref: imageWrapper
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(msgList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", {
              class: "block",
              style: _normalizeStyle(item.user ? 'flex-direction: row-reverse' : '')
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(Image), {
                  round: "",
                  width: "32px",
                  height: "32px",
                  src: 
                item.user
                  ? require('../../assets/icon/PropertyUser.png')
                  : require('../../assets/icon/PropertyAI.png')
              
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", {
                class: "arrow",
                style: _normalizeStyle(
              item.user
                ? 'border-left: 12px solid #fff;margin-right: 8px;'
                : 'border-right: 12px solid #fff;;margin-left: 8px;'
            )
              }, null, 4),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "cnt",
                  innerHTML: _unref(markdown).render(item.cnt)
                }, null, 8, _hoisted_8),
                (item.evaluate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_unref(Button), {
                        icon: 
                  item.evaluate === 'like'
                    ? require('../../assets/icon/zan-full.png')
                    : require('../../assets/icon/zan.png')
                ,
                        plain: "",
                        color: item.evaluate === 'like' ? '#1989FA' : '#969799',
                        class: "van-btn",
                        size: "small",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (changeEvaluate('like')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("满意")
                        ]),
                        _: 2
                      }, 1032, ["icon", "color"]),
                      _createVNode(_unref(Button), {
                        icon: 
                  item.evaluate === 'badreview'
                    ? require('../../assets/icon/bumanyi-full.png')
                    : require('../../assets/icon/bumanyi.png')
                ,
                        plain: "",
                        color: item.evaluate === 'badreview' ? '#1989FA' : '#969799',
                        class: "van-btn",
                        size: "small",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (changeEvaluate('badreview')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("不满意")
                        ]),
                        _: 2
                      }, 1032, ["icon", "color"]),
                      _createVNode(_unref(Button), {
                        icon: require('../../assets/icon/sync.png'),
                        plain: "",
                        color: "#969799",
                        class: "van-btn",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("重回答")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ]))
                  : _createCommentVNode("", true),
                (item.gather)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_unref(Button), {
                        icon: require('../../assets/icon/collection.png'),
                        plain: "",
                        color: "#1989FA",
                        class: "van-btn",
                        size: "small",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/collectionFrom')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("受试者信息采集单")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 4)
          ]))
        }), 128))
      ], 512),
      (sending.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(Loading)
          ]))
        : _createCommentVNode("", true),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_unref(Button), {
              icon: require('../../assets/icon/logout.png'),
              plain: "",
              size: "small",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (noService())),
              style: {"margin-right":"10px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("结束对话")
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_unref(Button), {
              icon: require('../../assets/icon/envelop-o.png'),
              plain: "",
              size: "small",
              style: {"margin-right":"10px"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/leaveMessage')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("留言")
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_unref(Button), {
              icon: require('../../assets/icon/service-o.png'),
              plain: "",
              size: "small",
              style: {"margin-right":"10px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("人工客服")
              ]),
              _: 1
            }, 8, ["icon"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_13,
      (_unref(msgList).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("img", {
              class: "d-img",
              src: _imports_0,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (saveMsg()))
            }),
            _withDirectives(_createElementVNode("input", {
              class: "d-input",
              placeholder: "请输入您的问题...",
              type: "text",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(msg) ? (msg).value = $event : msg = $event)),
              onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (sendMsg()), ["enter"]))
            }, null, 544), [
              [_vModelText, _unref(msg)]
            ]),
            _createVNode(_unref(Button), {
              style: {"width":"55px"},
              size: "small",
              type: "primary",
              disabled: _unref(msg) && !sending.value ? false : true,
              onClick: _cache[11] || (_cache[11] = ($event: any) => (sendMsg()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(sending.value ? "发送中" : "发送"), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_unref(Button), {
              style: {"width":"351px","height":"32px"},
              size: "small",
              type: "primary",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (newService()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("发起新咨询")
              ]),
              _: 1
            })
          ]))
    ], 512)
  ], 64))
}
}

})